export default "__VITE_PUBLIC_ASSET__ab5c79d7__"